import { render, staticRenderFns } from "./alipayAccount.vue?vue&type=template&id=57563cf0&scoped=true"
import script from "./alipayAccount.vue?vue&type=script&lang=js"
export * from "./alipayAccount.vue?vue&type=script&lang=js"
import style0 from "./alipayAccount.vue?vue&type=style&index=0&id=57563cf0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57563cf0",
  null
  
)

export default component.exports